import { simpleToFullLanguage } from "../../languages";
import { getLang } from "../../names";

export const transformAttachments = ({links, attachments}) => {
	links = getValidLinks(links).map(link => {
		return {
			ref: link.ref,
			description: link.description,
			format: 'link'
		};
	});

	attachments = getValidLinks(attachments).map(attachment => {
		return {
			ref: transformAttachmentRef(attachment.ref),
			description: attachment.description,
			format: 'attachment'
		};
	});

	return [...links, ...attachments];
};

const getValidLinks = (links) => {
	return links.filter(link => Object.keys(link.ref).length !== 0);
};

const transformAttachmentRef = (ref) => {
	const res = {};
	Object.keys(ref).forEach(country => {
		res[country] = ref[country].url;
	});

	return res;
};

export const transformFiles = (files) => {
	const description = {};
	const ref = {};

	files.forEach(file => {
		let lang ='';
		if (file.lang) {
			lang = file.lang;
		} else {
			const shortLang = getLang(file.name);
			lang = simpleToFullLanguage[shortLang.toLowerCase()];
		}
		
		description[lang] = file.name;
		ref[lang] = file.url;
	});

	return [{description, ref}];
};

export const transformSimpleFiles = (files) => {
	const newFiles = {};

	files.forEach(file => {
		let lang ='';
		if (file.lang) {
			lang = file.lang;
		} else {
			const shortLang = getLang(file.name);
			lang = simpleToFullLanguage[shortLang.toLowerCase()];
		}
		
		newFiles[lang] = file.url;
	});

	return newFiles;
};

export const transformMultilanguageFiles = (multilanguageFiles) => {
	const files = [];

	Object.values(multilanguageFiles).forEach(typeFiles => {
		Object.values(typeFiles).forEach(languageFiles => {
			Object.values(languageFiles).forEach(file => {
				const {name, url, countryCode, type, filesize, s3key} = file;

				files.push(
					{
						name,
						url,
						format: type,
						language: countryCode,
						filesize,
						s3key,
					}
				);
			});
		});
	});

	return files;
};

export const transformTags = (tags) => {
	if (!tags) {
		return [];
	}

	return tags.map(tag => tag?.value ? tag.value : tag);
};

export const transformAttachmentsNew = (attachments) => {
	attachments = getValidLinks(attachments).map(attachment => {
		return {
			refs: transformMultilanguageObject(attachment.ref),
			descriptions: transformMultilanguageObject(attachment.description),
			format: 'attachment'
		};
	});

	return attachments;
};

export const transformLinks = (links) => {
	links = getValidLinks(links).map(link => {
		return {
			refs: transformMultilanguageObject(link.ref),
			descriptions: transformMultilanguageObject(link.description),
		};
	});

	return links;
};

export const transformMultilanguageObject = (multilanguageObject) => {
	const res = [];

  Object.keys(multilanguageObject).forEach(key => {
    res.push({
			languageIsoCode: key,
			value: multilanguageObject[key].url || multilanguageObject[key]
		});
  });

  return res;
};

export const transformSeo = ({seoTitle, seoDescription, seoKeywords}) => {
	const allLanguages = [
		...Object.keys(seoTitle),
		...Object.keys(seoDescription),
		...Object.keys(seoKeywords)
	];

	const languages = [...new Set(allLanguages)];
	const seo = [];

	languages.forEach(lang => {
		const seoItem = {
			languageIsoCode: transformLanguageIsoCode(lang),
		};

		seoItem.seoTitle = seoTitle[lang] || '';

		seoItem.seoDescription = seoDescription[lang] || '';

		seoItem.seoKeywords = seoKeywords[lang] || '';

		seo.push(seoItem);
	});

	return seo;
};


export const transformLegalNotice = ({termsOfUse, copyrightAuthor, copyrightLicense}) => {
	const allLanguages = [
		...Object.keys(termsOfUse),
		...Object.keys(copyrightAuthor),
		...Object.keys(copyrightLicense)
	];

	const languages = [...new Set(allLanguages)];
	const legalNotice = [];

	languages.forEach(lang => {
		const legalNoticeItem = {
			languageIsoCode: transformLanguageIsoCode(lang)
		};

		legalNoticeItem.termsOfUse = termsOfUse[lang] || '';
		legalNoticeItem.copyrightAuthor = copyrightAuthor[lang] || '';
		legalNoticeItem.copyrightLicense = copyrightLicense[lang] || '';

		legalNotice.push(legalNoticeItem);
	});

	return legalNotice;
};

export const transformLinksAndAttachments = ({links, attachments}) => {
	const attachmentsObject = {};

	links.forEach(({description, ref, id}) => {
		const allLanguages = [...Object.keys(description), ...Object.keys(ref)];
		const languages = [...new Set(allLanguages)];

		languages.forEach(lang => {
			if (!attachmentsObject[lang]) {
				attachmentsObject[lang] = [];
			}

			if (ref?.[lang] && description?.[lang]) {
				attachmentsObject[lang].push({
					description: description?.[lang],
					ref: ref?.[lang],
					format: 'link',
					id: id,
				});
			}

		});
	});

	attachments.forEach(({description, ref, id}) => {
		const allLanguages = [...Object.keys(description), ...Object.keys(ref)];
		const languages = [...new Set(allLanguages)];

		languages.forEach(lang => {
			if (!attachmentsObject[lang]) {
				attachmentsObject[lang] = [];
			}

			if (ref?.[lang].url && description?.[lang]) {
				attachmentsObject[lang].push({
					description: description?.[lang],
					ref: ref?.[lang].url,
					format: 'attachment',
					id: id,
				});
			}
		});
	});

	return attachmentsObject;
};

export const transformMetadata = ({title, description, links, attachments, }) => {
	const linkAndAttachments = transformLinksAndAttachments({links, attachments});

	const allLanguages = [...Object.keys(title), ...Object.keys(description), ...Object.keys(linkAndAttachments)];
	const languages = [...new Set(allLanguages)];

	const metadata = [];

	languages.forEach(lang => {
		const metadataItem = {
			languageIsoCode: transformLanguageIsoCode(lang)
		};

		metadataItem.title = title?.[lang] || '';
		metadataItem.description = description?.[lang] || '';
		metadataItem.attachments = linkAndAttachments?.[lang] || [];


		metadata.push(metadataItem);
	});

	return metadata;
};

const transformLanguageIsoCode = (lang) => {
	return lang.replace('_', '-');
};